// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Audio.proto" (syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
// @generated message type with reflection information, may provide speed optimized methods
class SoundClassificationDetection$Type extends MessageType {
    constructor() {
        super("SoundClassificationDetection", [
            { no: 1, name: "generated_stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 4, name: "class_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message SoundClassificationDetection
 */
export const SoundClassificationDetection = new SoundClassificationDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpeechTranscription$Type extends MessageType {
    constructor() {
        super("SpeechTranscription", [
            { no: 1, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "recognized_speech", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message SpeechTranscription
 */
export const SpeechTranscription = new SpeechTranscription$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpeechRecognitionResult$Type extends MessageType {
    constructor() {
        super("SpeechRecognitionResult", [
            { no: 1, name: "generated_stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "best_transcription", kind: "message", T: () => SpeechTranscription },
            { no: 3, name: "all_transcriptions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpeechTranscription },
            { no: 5, name: "is_final", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "track_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message SpeechRecognitionResult
 */
export const SpeechRecognitionResult = new SpeechRecognitionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioEnvironment$Type extends MessageType {
    constructor() {
        super("AudioEnvironment", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "sounds", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SoundClassificationDetection },
            { no: 3, name: "speech", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpeechRecognitionResult },
            { no: 4, name: "speech_recognition_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message AudioEnvironment
 */
export const AudioEnvironment = new AudioEnvironment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Mp3ConversionRequest$Type extends MessageType {
    constructor() {
        super("Mp3ConversionRequest", [
            { no: 1, name: "input_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "retain", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Mp3ConversionRequest
 */
export const Mp3ConversionRequest = new Mp3ConversionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Mp3ConversionResponse$Type extends MessageType {
    constructor() {
        super("Mp3ConversionResponse", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "output_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "public_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "signed_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Mp3ConversionResponse
 */
export const Mp3ConversionResponse = new Mp3ConversionResponse$Type();
/**
 * @generated ServiceType for protobuf service AudioUtilityService
 */
export const AudioUtilityService = new ServiceType("AudioUtilityService", [
    { name: "ConvertToMp3", options: {}, I: Mp3ConversionRequest, O: Mp3ConversionResponse }
]);
/**
 * @generated ServiceType for protobuf service FakeServiceAudio
 */
export const FakeServiceAudio = new ServiceType("FakeServiceAudio", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
